import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { getCliente, postCliente, putCliente } from "../../../redux/actions";
import {
    FaBuilding,
    FaIdCard,
    FaLock,
    FaEnvelope,
    FaCheckCircle,
    FaEdit,
    FaPlus,
    FaTimes,
    FaUsers
} from "react-icons/fa";
import styles from "./gestionCliente.module.css";

const GestionCliente = () => {
    const [idCliente, setIdCliente] = useState(null);
    const [nombre, setNombre] = useState("");
    const [Nit, setNit] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [habilitado, setHabilitado] = useState(false);
    const [error, setError] = useState("");

    const dispatch = useDispatch();
    const clientes = useSelector((state) => state.clientes);

    useEffect(() => {
        dispatch(getCliente());
    }, [dispatch]);

    const handleGuardarCliente = async () => {
        if (!nombre.trim() || !Nit.trim() || !email.trim() || (!idCliente && !password.trim())) {
            setError("Todos los campos marcados son obligatorios.");
            return;
        }

        const clienteData = {
            id: idCliente,
            nombre,
            Nit,
            email,
            contrasena: password,
            activo: habilitado ? 1 : 0,
        };

        try {
            if (idCliente) {
                await dispatch(putCliente(clienteData));
                Swal.fire({
                    icon: "success",
                    title: "Cliente Actualizado",
                    text: "Los datos del cliente han sido modificados exitosamente.",
                    confirmButtonColor: "#0081cf",
                    background: "#0a0e14",
                    color: "#f0f6fc",
                });
            } else {
                await dispatch(postCliente(clienteData));
                Swal.fire({
                    icon: "success",
                    title: "Cliente Registrado",
                    text: "El nuevo cliente se ha creado correctamente en el sistema.",
                    confirmButtonColor: "#0081cf",
                    background: "#0a0e14",
                    color: "#f0f6fc",
                });
            }

            // Resetear formulario
            handleCancelarEdicion();
            dispatch(getCliente());
        } catch (err) {
            Swal.fire({
                icon: "error",
                title: "Error de Sistema",
                text: err.response?.data?.error || "Ocurrió un error inesperado al procesar la solicitud.",
                background: "#0a0e14",
                color: "#f0f6fc",
            });
        }
    };

    const handleSelectCliente = (e) => {
        const clienteSeleccionado = clientes.find(c => c.nombre === e.target.value);
        if (clienteSeleccionado) {
            setIdCliente(clienteSeleccionado.id);
            setNombre(clienteSeleccionado.nombre || "");
            setNit(clienteSeleccionado.Nit || "");
            setEmail(clienteSeleccionado.email || "");
            setPassword("");
            setHabilitado(clienteSeleccionado.activo === 1);
            setError("");
        }
    };

    const handleCancelarEdicion = () => {
        setIdCliente(null);
        setNombre("");
        setNit("");
        setEmail("");
        setPassword("");
        setHabilitado(false);
        setError("");
    };

    return (
        <div className={styles.container}>
            <div className={styles.headerSection}>
                <h2 className={styles.titulo}>Configuración de Clientes</h2>
            </div>

            <div className={styles.formCard}>
                <div className={styles.formGrid}>
                    <div className={styles.formGroup}>
                        <label className={styles.label}>Razón Social</label>
                        <div className={styles.inputWrapper}>
                            <FaBuilding className={styles.inputIcon} />
                            <input
                                type="text"
                                placeholder="Nombre completo del cliente"
                                value={nombre}
                                onChange={(e) => setNombre(e.target.value)}
                                className={styles.input}
                            />
                        </div>
                    </div>

                    <div className={styles.formGroup}>
                        <label className={styles.label}>NIT (Sin Dígito)</label>
                        <div className={styles.inputWrapper}>
                            <FaIdCard className={styles.inputIcon} />
                            <input
                                type="text"
                                placeholder="Ej: 900.000.000"
                                value={Nit}
                                onChange={(e) => setNit(e.target.value)}
                                className={styles.input}
                            />
                        </div>
                    </div>

                    <div className={styles.formGroup}>
                        <label className={styles.label}>Correo Electrónico</label>
                        <div className={styles.inputWrapper}>
                            <FaEnvelope className={styles.inputIcon} />
                            <input
                                type="email"
                                placeholder="contacto@cliente.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className={styles.input}
                            />
                        </div>
                    </div>

                    <div className={styles.formGroup}>
                        <label className={styles.label}>Contraseña Acceso</label>
                        <div className={styles.inputWrapper}>
                            <FaLock className={styles.inputIcon} />
                            <input
                                type="password"
                                placeholder={idCliente ? "••••••••" : "Mínimo 8 caracteres"}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className={styles.input}
                            />
                        </div>
                    </div>
                </div>

                <div className={styles.checkboxWrapper} onClick={() => setHabilitado(!habilitado)} style={{ cursor: 'pointer' }}>
                    <div className={styles.checkboxContainer}>
                        <input
                            type="checkbox"
                            checked={habilitado}
                            onChange={(e) => setHabilitado(e.target.checked)}
                        />
                        <span style={{ fontWeight: '600', fontSize: '0.9rem' }}>Estado del Cliente: {habilitado ? 'Activo' : 'Inactivo'}</span>
                    </div>
                </div>

                {error && <p className={styles.error}>{error}</p>}

                <div className={styles.buttonGroup}>
                    <button onClick={handleGuardarCliente} className={styles.boton}>
                        {idCliente ? <><FaEdit /> Actualizar Información</> : <><FaPlus /> Registrar Nuevo Cliente</>}
                    </button>

                    {idCliente && (
                        <button onClick={handleCancelarEdicion} className={styles.botonCancelar}>
                            <FaTimes /> Cancelar
                        </button>
                    )}
                </div>

                {clientes?.length > 0 && (
                    <div className={styles.registeredSection}>
                        <label className={styles.label} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <FaUsers /> Base de Clientes Registrados:
                        </label>
                        <div className={styles.inputWrapper}>
                            <FaBuilding className={styles.inputIcon} style={{ zIndex: 5 }} />
                            <select
                                className={styles.select}
                                onChange={handleSelectCliente}
                                value={idCliente ? nombre : ""}
                            >
                                <option value="" disabled>Seleccionar un cliente para editar...</option>
                                {clientes.map((c) => (
                                    <option key={c.id} value={c.nombre}>
                                        {c.nombre} {c.Nit ? `(${c.Nit})` : ''}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default GestionCliente;
